import React from 'react';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    // Link
} from "react-router-dom";

import SiteLayout from './SiteLayout';

const Routers: React.FunctionComponent = (): JSX.Element => {
    return (
        <Router>
            <Switch>
                <Route path='/'>
                    <SiteLayout />
                </Route>
            </Switch>
        </Router>
    );
};

export default Routers;
